const API_BASE = process.env.NODE_ENV === 'production'
  ? '/api'
  : 'http://localhost:3847/api';

class API {
  // Get auth token from localStorage
  static getToken() {
    return localStorage.getItem('loafy_admin_token');
  }

  // Set auth token in localStorage
  static setToken(token) {
    localStorage.setItem('loafy_admin_token', token);
  }

  // Remove auth token
  static removeToken() {
    localStorage.removeItem('loafy_admin_token');
  }

  // Login
  static async login(password) {
    try {
      const response = await fetch(`${API_BASE}/admin/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ password })
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || 'Login failed');
      }

      if (data.token) {
        this.setToken(data.token);
      }

      return data;
    } catch (error) {
      throw error;
    }
  }

  // Verify token
  static async verifyToken() {
    try {
      const token = this.getToken();
      if (!token) return false;

      const response = await fetch(`${API_BASE}/admin/verify`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      return response.ok;
    } catch (error) {
      return false;
    }
  }

  // Get dashboard stats
  static async getStats() {
    try {
      const token = this.getToken();
      const response = await fetch(`${API_BASE}/admin/stats`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || 'Failed to get stats');
      }

      return data;
    } catch (error) {
      throw error;
    }
  }

  // Change password
  static async changePassword(currentPassword, newPassword) {
    try {
      const token = this.getToken();
      const response = await fetch(`${API_BASE}/admin/change-password`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ currentPassword, newPassword })
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || 'Failed to change password');
      }

      return data;
    } catch (error) {
      throw error;
    }
  }

  // Get system metrics
  static async getSystemMetrics() {
    try {
      const token = this.getToken();
      const response = await fetch(`${API_BASE}/admin/system-metrics`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      if (!response.ok) {
        const data = await response.json();
        throw new Error(data.error || 'Failed to get system metrics');
      }

      return await response.json();
    } catch (error) {
      throw error;
    }
  }

  // Get recent visitors
  static async getRecentVisitors() {
    try {
      const token = this.getToken();
      const response = await fetch(`${API_BASE}/admin/recent-visitors`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || 'Failed to get recent visitors');
      }

      return data;
    } catch (error) {
      throw error;
    }
  }

  // Logout
  static logout() {
    this.removeToken();
  }
}

export default API;
